<template>
    <section class="quicktrial-final__wrapper">
        <header class="onboarding-quicktrial__informations-header">
            <SaasIcon
                icon="svgLogoSellsyText"
                class="onboarding-quicktrial__informations-header-logo"
                :width="isDesktop ? 118 : 168"
                :height="isDesktop ? 28 : 40"
            />
        </header>
        <article class="quicktrial-final__inner">
            <div ref="lottie"></div>

            <p
                :class="[
                    'quicktrial-final__title',
                    isDesktop ? 'typographies-display-brand-medium' : 'typographies-display-small',
                ]"
                v-html="
                    $t.__(
                        'pages.onboarding.trial.OnboardingQuickTrialFinal.wait_while_account_creating',
                        { br: '<br>' },
                    )
                "
            />
        </article>
    </section>
</template>

<script>
import lottieWeb from 'lottie-web';
import animation from 'animations/lottie/lf20_w8m8u5up.json';
import OnboardingTrialApi from 'api/onboarding/trial/onboardingTrial';
import { isDesktop } from 'utils/global';
import SaasIcon from 'vcomponents/common/SaasIcon.vue';

export default {
    components: {
        SaasIcon,
    },
    props: {
        response: {
            type: Object,
            required: true,
            default: null,
        },
    },
    data() {
        return {
            isDesktop: isDesktop(),
            isActiveAccountTimer: null,
            failureCount: 0,
        };
    },
    mounted() {
        // We need specific class to this component to override body styles without reload page
        document.body.classList.add('page-onboarding-trial-quick-final');
        this.checkIsActiveAccount();
        lottieWeb.loadAnimation({
            container: this.$refs.lottie, // the dom element that will contain the animation
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animation, // the path to the animation json
        });
        window.addEventListener('resize', () => {
            this.isDesktop = isDesktop();
        });
    },
    beforeUnmount() {
        clearInterval(this.isActiveAccountTimer);
    },
    methods: {
        checkIsActiveAccount() {
            const MAX_CONSECUTIVE_FAILURES = 30;

            this.isActiveAccountTimer = setInterval(() => {
                OnboardingTrialApi.isActiveAccount()
                    .then(({ status }) => {
                        this.failureCount = 0;

                        if (status === 'success') {
                            this.completeActivation();
                        }
                    })
                    .catch((err) => {
                        // Session expired server-side: stop polling and send the user back to the start.
                        if (err?.response?.status === 422) {
                            clearInterval(this.isActiveAccountTimer);
                            this.$router.push({ name: 'onboarding.quicktrial.signup' });
                            return;
                        }

                        this.failureCount += 1;
                        if (this.failureCount >= MAX_CONSECUTIVE_FAILURES) {
                            clearInterval(this.isActiveAccountTimer);
                            this.$router.push({ name: 'onboarding.quicktrial.signup' });
                        }
                    });
            }, 1000);
        },
        completeActivation() {
            clearInterval(this.isActiveAccountTimer);

            if (this.isDesktop) {
                window.location.replace(this.response.redirectPath + '?onboarding=true');
            } else {
                this.$router.push({ name: 'onboarding.trial_mobile' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.quicktrial-final__wrapper {
    margin: -32px -32px auto;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    height: 100vh;
    width: 100vw;
    padding: var(--spacing-6);
}

.onboarding-quicktrial__informations {
    &-header {
        &-logo {
            color: var(--colors-common-text-brand-secondary-blue);
        }

        @media screen and (max-width: 1023px) {
            text-align: center;
        }
    }
}

.quicktrial-final__inner {
    max-width: 580px;
    margin: auto;
    display: flex;
    flex-direction: column;
}

.quicktrial-final__title {
    text-align: center;
    color: var(--colors-common-text-brand-secondary-blue);
}
</style>

<style lang="scss">
.page-onboarding-trial-quick-final #sellsy_app,
#sellsy_app:has(.onboarding-quicktrial-mobile) {
    min-width: auto !important;
    background-color: var(
        --colors-component-background-illustration-brand-secondary-grey
    ) !important;
}
</style>
